"use client";
import {
  __async
} from "../chunk-GOCCUU3Z.js";
import { hexStringToBase64, WalletType } from "@getpara/web-sdk";
function offRampSend(_0, _1, _2, _3) {
  return __async(this, arguments, function* (para, { id: purchaseId, provider, walletId, walletType, address, testMode = false }, setOnRampPurchase, {
    assetQuantity,
    fiat,
    fiatQuantity,
    chainId,
    destinationAddress,
    contractAddress
  }) {
    var _a, _b, _c;
    if (!purchaseId || !walletId || !walletType || !provider) {
      throw new Error("Missing required fields");
    }
    try {
      const { tx, message, network, asset } = yield para.ctx.client.generateOffRampTx(para.getUserId(), {
        walletId,
        walletType,
        provider,
        chainId,
        destinationAddress,
        sourceAddress: address,
        contractAddress,
        testMode,
        assetQuantity
      });
      let signature;
      switch (walletType) {
        case WalletType.EVM:
          signature = (_a = yield para.signTransaction({
            walletId,
            rlpEncodedTxBase64: hexStringToBase64(tx),
            chainId
          })) == null ? void 0 : _a.signature;
          break;
        case WalletType.SOLANA:
          signature = (_b = yield para.signMessage({ walletId, messageBase64: message })) == null ? void 0 : _b.signature;
          break;
        default:
          throw new Error(`Unsupported wallet type: ${walletType}`);
      }
      const { txHash } = yield para.ctx.client.sendOffRampTx(para.getUserId(), {
        tx,
        signature: walletType === "EVM" ? `0x${signature}` : signature,
        sourceAddress: address,
        network,
        walletId,
        walletType
      });
      const updated = yield para.ctx.client.updateOnRampPurchase({
        userId: para.getUserId(),
        walletId,
        purchaseId,
        updates: {
          fiat,
          fiatQuantity,
          assetQuantity,
          network,
          asset
        }
      });
      setOnRampPurchase(updated);
      return txHash;
    } catch (e) {
      throw new Error(((_c = e.response) == null ? void 0 : _c.data) || e.message);
    }
  });
}
export {
  offRampSend
};
